import React, { useState, useEffect } from 'react';
import {
    Modal,
    ResourceItem,
    ResourceList,
    TextStyle,
    Stack,
    Thumbnail,
    Spinner
} from '@shopify/polaris';
import { apiFetch } from '../common/Helpers';
import Cookies from "js-cookie";

function handleProductItemClick(e, id) {
    const shopOrigin = Cookies.get("shopOrigin");
    window.open(`https://${shopOrigin}/admin/products/${id}`, '_blank');
}

export function ProductsByOptionValueModal({ active, onClose, optionName, optionValue }) {

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (active && optionName && optionValue) {
            setLoading(true);
            apiFetch(`api/products/byOptionValue?optionName=${encodeURIComponent(optionName)}&optionValue=${encodeURIComponent(optionValue)}`, {
                method: "GET",
            })
                .then(response => response.json())
                .then(data => {
                    setProducts(data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [active, optionName, optionValue]);

    const renderResourceItem = (item) => {
        const { id, title, legacyResourceId, image } = item;

        return (
            <ResourceItem
                id={id}
                url={null}
                verticalAlignment="center"
                media={<Thumbnail source={image} alt="image" size="small" />}
                onClick={(e) => handleProductItemClick(e, legacyResourceId)}>
                <TextStyle variation="strong">{title}</TextStyle>
                <br />
                <TextStyle variation="subdued">{legacyResourceId}</TextStyle>
            </ResourceItem>
        );
    };

    return (
        <Modal
            open={active}
            onClose={onClose}
            title={`Products with ${optionName}: ${optionValue}`}
            secondaryActions={[{
                content: 'Close',
                onAction: onClose,
            }]}
        >
            <Modal.Section>
                {loading ? (
                    <Stack distribution="center">
                        <Spinner size="large" />
                    </Stack>
                ) : (
                    <ResourceList
                        resourceName={{ singular: 'product', plural: 'products' }}
                        items={products}
                        renderItem={renderResourceItem}
                        emptyState={<p>No products found with this option value.</p>}
                    />
                )}
            </Modal.Section>
        </Modal>
    );
}

export default ProductsByOptionValueModal;
